// Import images
import Chipster from "./assets/images/Chipster.png";
import DuoChoco from "./assets/images/DuoChoco.png";
import Sucranelle from "./assets/images/Sucranelle.png";
import Tofféo from "./assets/images/Toffeo.png";
import Scarlette from "./assets/images/Scarlette.png";
import Pistou from "./assets/images/Pistou.png";
import Nuage from "./assets/images/Nuage.png";
import Lemube from "./assets/images/Lemube.png";
import Nougato from "./assets/images/Nougato.png";
import Choconoix from "./assets/images/Choconoix.png";
import Beurreberry from "./assets/images/Beurreberry.png";

const recipes = {
  "Chipster 140": {
    image: Chipster,
    subtitle: "Chocolate Chip",
    ingredients: {
      "Butter": { "Butter": { amount: 450, unit: "g" } },
      "Sugars": { "Brown Sugar": { amount: 540, unit: "g" }, "Granulated Sugar": { amount: 240, unit: "g" } },
      "Eggs": { "Whole Eggs": { amount: 3, unit: "x" }, "Egg Yolks": { amount: 3, unit: "x" } },
    }
  },
  "DuoChoco 140": {
    image: DuoChoco,
    subtitle: "Double Chocolate",
    ingredients: {
      "Butter": { "Butter": { amount: 450, unit: "g" } },
      "Sugars": { "Brown Sugar": { amount: 540, unit: "g" }, "Granulated Sugar": { amount: 240, unit: "g" } },
    }
  },
  "Beurreberry": {
    image: Beurreberry,
    ingredients: {
      "Sugars": { "Brown Sugar": 100, "Granulated Sugar": 50 },
      "Eggs": { "Whole Eggs": 3, "Egg Yolks": 2 },
      "Flour": { "All-Purpose Flour": 200, "Cornstarch": 20, "Baking Soda": 5, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 150, "Chocolate Chips": 50 }
    }
  },
  "Choconoix": {
    image: Choconoix,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  },
  "Lemube": {
    image: Lemube,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  },
  "Nougato": {
    image: Nougato,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  },
  "Nuage": {
    image: Nuage,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  },
  "Pistou": {
    image: Pistou,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  },
  "Scarlette": {
    image: Scarlette,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  },
  "Tofféo": {
    image: Tofféo,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  },
  "Sucranelle": {
    image: Sucranelle,
    ingredients: {
      "Sugars": { "Brown Sugar": 90, "Granulated Sugar": 40 },
      "Eggs": { "Whole Eggs": 2, "Egg Yolks": 1 },
      "Flour": { "All-Purpose Flour": 220, "Cornstarch": 15, "Baking Soda": 4, "Salt": 2 },
      "Chocolate": { "Semi-Sweet Chocolate": 140, "Chocolate Chips": 70 },
      "Nuts": { "Hazelnuts": 140 }
    }
  }
};

export default recipes;
